import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";

import IconButton from "@mui/material/IconButton";
import RemoveIcon from "@mui/icons-material/Remove";
import InputAdornment from "@mui/material/InputAdornment";

// import Checkbox from "@mui/material/Checkbox";
// import Autocomplete from "@mui/material/Autocomplete";
// import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
// import CheckBoxIcon from "@mui/icons-material/CheckBox";

import { useAtom } from "jotai";
import { themeAtom, isMobileAtom, jobTypesAtom } from "../-Atoms";

import { useDynamicDebounceCallback } from "react-dynamic-debounce";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";

import { db, collection, doc, updateDoc } from "../firebaseConfig";

const ClientTabBreakdownItem = ({
  item,
  items,
  setItems,
  index,
  showRemoveBreakdownItem,
  clientData,
}) => {
  // console.log(clientData);
  const [isMobile] = useAtom(isMobileAtom);
  const [theme] = useAtom(themeAtom);
  const [jobTypes] = useAtom(jobTypesAtom);

  const updateFSNow = (id, field, value) => {
    // console.log(id, field, value);
    // return;
    updateDoc(doc(collection(db, "ClientDatabase"), id), { [field]: value })
      .catch((error) => {
        console.log(error);
      });
  };

  const [updateFS] = useDynamicDebounceCallback(updateFSNow, {
    defaultDelay: 700,
    maxDelay: 2000,
    minSamples: 6,
    maxSamples: 4,
    delayFunction: (averageGap) => Math.floor(averageGap + 300),
  });

  const [description, setDescription] = useState("");
  const [jobTypesFilter, setJobTypesFilter] = useState([]);
  const [expectedPerHour, setExpectedPerHour] = useState("");
  const [costPerFile, setCostPerFile] = useState("");
  const [existingItem, setExistingItem] = useState("");
  const [dontAddToTotalSupplied, setDontAddToTotalSupplied] = useState(false);

  useEffect(() => {
    setDescription(item.description);
    setJobTypesFilter(item.jobTypesFilter || []);
    setExpectedPerHour(item.expectedPerHour);
    setCostPerFile(item.costPerFile);
    setExistingItem(item.existingItem);
    setDontAddToTotalSupplied(item.dontAddToTotalSupplied);
  }, [item]);

  const removeBreakdownItem = () => {
    items.splice(index, 1);
    setItems([...items]);
    updateDoc(doc(collection(db, "ClientDatabase"), clientData.id), { imageBreakdown: items })
      .catch((e) => console.log(e));
  };

  const handleJobTypeFilterChange = (event) => {
    const newFilter = event.target.value;
    setJobTypesFilter(newFilter);
    item.jobTypesFilter = newFilter;
    updateFS(clientData.id, "imageBreakdown", [...items]);
  };

  const handleDontAddToTotalSupplied = (event, checked) => {
    setDontAddToTotalSupplied(checked);
    item.dontAddToTotalSupplied = checked;
    updateFS(clientData.id, "imageBreakdown", [...items]);
  };
  return (
    <div
      style={{
        display: "block",
        borderRadius: 5,
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 20,
        paddingRight: 20,
        background:
          theme === "dark"
            ? "rgba(255,255,255,0.03)"
            : "rgba(0,0,0,0.04)",
        marginBottom: 10,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
          gap: 15,
          marginBottom: 4,
        }}
      >
        <TextField
          inputProps={{
            style: {
              fontSize: 15,
              fontWeight: existingItem ? "bold" : "",
              color:
                theme === "dark"
                  ? "rgba(255, 255, 255, 0.6)"
                  : "rgba(0, 0, 0, 0.6)",
            },
          }}
          InputLabelProps={{ style: { fontSize: 15 } }}
          placeholder="Replace Me - e.g Ghost / Life / Jackets / T-Shirts etc..."
          variant="standard"
          size="small"
          multiline
          value={description}
          onChange={(e) => {
            setDescription(e.target.value);
            item.description = e.target.value;
            // console.log(clientData.id)
            updateFS(clientData.id, "imageBreakdown", [...items]);
          }}
          sx={{
            width: "100%",
            opacity: 1,
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor:
                theme === "dark"
                  ? "rgba(255, 255, 255, 0.6)"
                  : "rgba(0, 0, 0, 0.6)",
            },
          }}
          InputProps={{
            endAdornment: showRemoveBreakdownItem ? (
              <InputAdornment position="end">
                <IconButton onClick={removeBreakdownItem}>
                  <RemoveIcon />
                </IconButton>
              </InputAdornment>
            ) : null,
            disableUnderline: true,
          }}
        />
      </div>
      <FormControl
        fullWidth
        variant="filled"
        size="small"
        sx={{
          marginTop: 1.5,
          marginBottom: 3,
          "& .MuiFilledInput-root": {
            borderRadius: "8px",
            backgroundColor:
              theme === "dark" ? "rgba(50,50,50,0.5)" : "rgba(245,245,245,0.9)",
            "&:hover": {
              backgroundColor:
                theme === "dark" ? "rgba(60,60,60,0.6)" : "rgba(250,250,250,1)",
            },
            "&.Mui-focused": {
              backgroundColor:
                theme === "dark" ? "rgba(60,60,60,0.6)" : "rgba(250,250,250,1)",
            },
          },
        }}
      >
        <InputLabel id="job-type-filter-label">Job Types</InputLabel>
        <Select
          labelId="job-type-filter-label"
          id="job-type-filter"
          multiple
          value={jobTypesFilter}
          onChange={handleJobTypeFilterChange}
          disableUnderline
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <em style={{ opacity: 0.6 }}>None selected</em>;
            }
            return (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((value) => {
                  const jt = jobTypes.find((j) => j.id === value);
                  if (!jt) return null;
                  return (
                    <Chip
                      key={value}
                      label={`${jt.name} (-${jt.nameShort})`}
                      size="small"
                      sx={{ height: 20, fontSize: 11 }}
                    />
                  );
                })}
              </Box>
            );
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
                backgroundColor:
                  theme === "dark" ? "rgba(30,30,30,1)" : "rgba(255,255,255,1)",
              },
            },
          }}
        >
          {jobTypes &&
            jobTypes.map((jt) => {
              const combined = `${jt.name} (-${jt.nameShort})`;
              const isSelected = jobTypesFilter.includes(jt.id);
              return (
                <MenuItem key={jt.id} value={jt.id}>
                  <Checkbox
                    checked={isSelected}
                    size="small"
                    sx={{
                      color: theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
                      "&.Mui-checked": {
                        color: theme === "dark" ? "#90caf9" : "#1976d2",
                      },
                    }}
                  />
                  <Box component="span" sx={{ fontSize: 14 }}>
                    {combined}
                  </Box>
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 18,
          marginBottom: 5,
          flexWrap: isMobile ? "wrap" : "nowrap",
        }}
      >
        <TextField
          inputProps={{ style: { fontSize: 15 } }}
          InputLabelProps={{ style: { fontSize: 15 } }}
          variant="filled"
          label={"Cost Per File"}
          size="small"
          sx={{
            width: isMobile ? "47%" : "100%",
            opacity: 1,
          }}
          value={costPerFile}
          InputProps={{ disableUnderline: true }}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/[^0-9]/g, "");
            setCostPerFile(numericValue);
            item.costPerFile = e.target.value;
            updateFS(clientData.id, "imageBreakdown", [...items]);
          }}
        />
        <TextField
          inputProps={{ style: { fontSize: 15 } }}
          InputLabelProps={{ style: { fontSize: 15 } }}
          variant="filled"
          label={"Expected Per Hour"}
          size="small"
          sx={{
            width: isMobile ? "47%" : "100%",
            opacity: 1,
          }}
          value={expectedPerHour}
          InputProps={{ disableUnderline: true }}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/[^0-9]/g, "");
            setExpectedPerHour(numericValue);
            item.expectedPerHour = e.target.value;
            updateFS(clientData.id, "imageBreakdown", [...items]);
          }}
        />
      </div>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={dontAddToTotalSupplied}
              onChange={handleDontAddToTotalSupplied}
            />
          }
          label="Don't Add To Total Supplied"
        />
      </FormGroup>
    </div>
  );
};

export default ClientTabBreakdownItem;

// const findJobType = (option, jobTypes) => {
//   if (option.name) return `${option.name} (-${option.nameShort})`;
//   const jt = jobTypes.find((obj) => obj.id === option);
//   return `${jt.name} (-${jt.nameShort})`;
// };
